"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var sockjs_client_1 = __importDefault(require("sockjs-client"));
var api_1 = require("@opentelemetry/api");
var instrumentation_1 = require("../instrumentation");
var RECONNECTION_DELAY = 2000; // 2s
var tracer = api_1.trace.getTracer(instrumentation_1.OTEL_TRACER_NAME);
var Connection = /** @class */ (function () {
    function Connection(url, connectionOptions, sockJsOptions) {
        if (connectionOptions === void 0) { connectionOptions = {}; }
        if (sockJsOptions === void 0) { sockJsOptions = {}; }
        var _this = this;
        this.connect = function () {
            var carrier = {};
            api_1.propagation.inject(api_1.context.active(), carrier);
            var queryParams = new URLSearchParams(carrier).toString();
            var urlWithContext = "".concat(_this.url, "?").concat(queryParams);
            _this.sockJs = new sockjs_client_1.default(urlWithContext, null, _this.sockJsOptions);
            _this.sockJs.onopen = _this.createOnOpen();
            _this.sockJs.onmessage = _this.createOnMessage();
            _this.sockJs.onclose = _this.createOnClose();
            _this.sockJs.onerror = _this.createOnClose();
        };
        this.reconnect = function () {
            tracer.startActiveSpan((0, instrumentation_1.withPrefix)('Connection.reconnect'), {}, function (span) { return __awaiter(_this, void 0, void 0, function () {
                var reconnectIn;
                var _this = this;
                return __generator(this, function (_a) {
                    if (this.online) {
                        this.reconnectionAttempt = 0;
                        span.setAttributes({
                            online: true,
                        });
                        span.end();
                        return [2 /*return*/];
                    }
                    reconnectIn = this.reconnectionAttempt * RECONNECTION_DELAY;
                    // eslint-disable-next-line no-console
                    console.warn("SockJs connection closed. Reconnect in ".concat(reconnectIn / 1000, "s. Buffered messages: ").concat(this.messageQueue.length));
                    span.setAttributes({
                        online: false,
                        reconnectIn: "".concat(reconnectIn / 1000, "s"),
                        messageQueueLength: this.messageQueue.length,
                    });
                    this.reconnectionAttempt++;
                    setTimeout(function () {
                        _this.connect();
                        span.end();
                    }, reconnectIn);
                    return [2 /*return*/];
                });
            }); });
        };
        this.close = function () {
            if (_this.sockJs) {
                _this.sockJs.onclose = _this.createOnClose(false);
                _this.sockJs.onerror = _this.createOnClose(false);
                _this.sockJs.close();
            }
        };
        this.send = function (message) {
            if (!_this.online || !_this.sockJs) {
                _this.messageQueue.push(message);
                return;
            }
            _this.sockJs.send(message);
        };
        this.createOnMessage = function () { return function (event) {
            _this.messageHandlers.forEach(function (handler) {
                handler(event.data);
            });
        }; };
        this.createOnOpen = function () { return function () {
            _this.online = true;
            _this.reconnectionAttempt = 0;
            _this.messageQueue.forEach(_this.send);
            _this.messageQueue = [];
            _this.connectHandlers.forEach(function (handler) { return handler(); });
        }; };
        this.createOnClose = function (reconnect) {
            if (reconnect === void 0) { reconnect = true; }
            return function () {
                _this.online = false;
                _this.disconnectHandlers.forEach(function (handler) { return handler(); });
                if (reconnect) {
                    _this.reconnect();
                }
            };
        };
        this.isOnline = function () { return _this.online; };
        this.url = url;
        var _a = connectionOptions.onConnect, onConnect = _a === void 0 ? function () { } : _a, _b = connectionOptions.onDisconnect, onDisconnect = _b === void 0 ? function () { } : _b, _c = connectionOptions.autoConnect, autoConnect = _c === void 0 ? true : _c;
        this.sockJsOptions = sockJsOptions;
        this.messageHandlers = new Set();
        this.connectHandlers = new Set();
        this.disconnectHandlers = new Set();
        this.online = false;
        this.onConnect(onConnect);
        this.onDisconnect(onDisconnect);
        this.reconnectionAttempt = 0;
        this.messageQueue = [];
        if (autoConnect) {
            tracer.startActiveSpan((0, instrumentation_1.withPrefix)('Connection.constructor.autoConnect'), {}, function (span) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.connect();
                    span.end();
                    return [2 /*return*/];
                });
            }); });
        }
    }
    Connection.prototype.onMessage = function (handler) {
        if (typeof handler === 'function') {
            this.messageHandlers.add(handler);
        }
        return this;
    };
    Connection.prototype.offMessage = function (handler) {
        this.messageHandlers.delete(handler);
        return this;
    };
    Connection.prototype.onConnect = function (handler) {
        if (typeof handler === 'function') {
            this.connectHandlers.add(handler);
        }
        return this;
    };
    Connection.prototype.offConnect = function (handler) {
        this.connectHandlers.delete(handler);
        return this;
    };
    Connection.prototype.onDisconnect = function (handler) {
        if (typeof handler === 'function') {
            this.disconnectHandlers.add(handler);
        }
        return this;
    };
    Connection.prototype.offDisconnect = function (handler) {
        this.disconnectHandlers.delete(handler);
    };
    return Connection;
}());
exports.default = Connection;
//# sourceMappingURL=Connection.js.map